module.exports = __webpack_public_path__ + "static/media/banner2.131a3734.png";